import { render, staticRenderFns } from "./Step2.vue?vue&type=template&id=0fefcf1a&"
import script from "./Step2.vue?vue&type=script&lang=ts&"
export * from "./Step2.vue?vue&type=script&lang=ts&"
import style0 from "./Step2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
